import React, { useEffect, useRef } from "react";
import { useReducedMotion } from "../lib/motionPref";

const COLORS = ["176,38,255", "0,240,255", "140,90,255", "255,215,0"];

export const QuantumField = () => {
  const ref = useRef(null);
  const reduced = useReducedMotion();

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    const mobile = window.innerWidth < 768;
    const N = mobile ? 900 : 2600;
    let w, h, raf, t = 0;
    const mouse = { x: -9999, y: -9999 };
    const resize = () => {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
    };
    resize();
    const ps = Array.from({ length: N }, () => ({
      x: Math.random() * w, y: Math.random() * h,
      vx: (Math.random() - 0.5) * 0.15, vy: (Math.random() - 0.5) * 0.15,
      r: Math.random() * 1.3 + 0.2, c: COLORS[(Math.random() * COLORS.length) | 0], a: Math.random() * 0.6 + 0.15,
    }));
    const draw = () => {
      t += 1;
      ctx.clearRect(0, 0, w, h);
      const pattern = Math.sin(t / 900) > 0.92;
      for (const p of ps) {
        if (!reduced) {
          if (pattern) {
            const dx = w / 2 - p.x, dy = h / 2 - p.y;
            p.vx += -dy * 0.0000009 + dx * 0.0000004;
            p.vy += dx * 0.0000009 + dy * 0.0000004;
          }
          const mx = p.x - mouse.x, my = p.y - mouse.y, d2 = mx * mx + my * my;
          if (d2 < 14000) {
            p.vx += mx / d2 * 0.6;
            p.vy += my / d2 * 0.6;
          }
          p.vx *= 0.995; p.vy *= 0.995;
          p.x += p.vx + (Math.random() - 0.5) * 0.05;
          p.y += p.vy + (Math.random() - 0.5) * 0.05;
          if (p.x < 0) p.x = w; if (p.x > w) p.x = 0;
          if (p.y < 0) p.y = h; if (p.y > h) p.y = 0;
        }
        ctx.fillStyle = `rgba(${p.c},${p.a})`;
        ctx.fillRect(p.x, p.y, p.r, p.r);
      }
      if (!reduced) raf = requestAnimationFrame(draw);
    };
    draw();
    const move = (e) => { mouse.x = e.clientX; mouse.y = e.clientY; };
    window.addEventListener("resize", resize);
    window.addEventListener("pointermove", move);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("pointermove", move);
    };
  }, [reduced]);

  return <canvas ref={ref} className="fixed inset-0 pointer-events-none z-0" aria-hidden data-testid="quantum-field" />;
};
